import { createSlice } from "@reduxjs/toolkit";
import { Company } from "../../company-page/store/slice";

export enum RoleCode {
  Customer = "customer",
  Internal = "internal",
  Sap = "sap",
}

export type Role = {
  id: number;
  code: RoleCode;
  name: string;
};

export type User = {
  id: number;
  name: string;
  email: string;
  companies?: Company[];
  roles?: Role[];
  is_verified?: boolean;
  is_girteka_user?: boolean;
  notifications_enabled?: boolean;
  is_deleted?: boolean;
  owned_bookings_count?: number;
};

type InitialState = {
  data: User[];
  isLoading: boolean;
};

const initialState: InitialState = {
  data: [],
  isLoading: false,
};

const userSlice = createSlice({
  name: "userSlice",
  initialState,
  reducers: {
    fetch: (state, action) => {
      state.isLoading = true;
    },
    setData: (state, action) => {
      state.data = action.payload;
    },
    setIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    reset: () => initialState,
  },
});

export default userSlice;
